<template>
  <div style="margin: 15px; margin-right: 30px">
    <el-form ref="form" :rules="rules" :model="form" label-width="130px">
      <el-form-item label="发票抬头" prop="invoiceTitle">
        <el-input
          v-model.trim="form.invoiceTitle"
          placeholder="请输入发票抬头"
          @input="handleInput('invoiceTitle')"
        />
      </el-form-item>
      <!-- <el-form-item label="开票类型" prop="type">
        <el-select v-model="form.type" filterable placeholder="开票类型" @change="changeType">
          <el-option
            v-for="item in parentData.typeOptions"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          />
        </el-select>
      </el-form-item> -->
      <el-form-item label="纳税人识别号" prop="taxRegistrationNumber">
        <el-input
          v-model.trim="form.taxRegistrationNumber"
          placeholder="纳税人识别号"
          @input="handleInput('taxRegistrationNumber')"
        />
      </el-form-item>
      <el-form-item label="基本开户银行" prop="bank">
        <el-select v-model="form.bank" filterable placeholder="基本开户银行">
          <el-option
            v-for="item in parentData.bankOptions"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="基本开户账号" prop="accountNumber">
        <el-input
          v-model.trim="form.accountNumber"
          placeholder="请输入基本开户账号"
          @input="handleInput('accountNumber')"
        />
      </el-form-item>
      <el-form-item label="注册场所地址" prop="registeredAddress">
        <el-input
          v-model.trim="form.registeredAddress"
          placeholder="请输入注册场所地址"
          @input="handleInput('registeredAddress')"
        />
      </el-form-item>
      <el-form-item label="注册固定电话" prop="registeredFixedPhone">
        <el-input
          v-model.trim="form.registeredFixedPhone"
          placeholder="请输入注册固定电话"
          @input="handleInput('registeredFixedPhone')"
        />
      </el-form-item>
      <template v-if="isReceiverUserCodeShow">
        <el-form-item label="实际收票人" prop="receiverUserCode">
          <el-select v-model="form.receiverUserCode" placeholder="实际收票人">
            <el-option
              v-for="item in receiverUserCodeOptions"
              :key="item.partyCode"
              :label="item.userName"
              :value="item.partyCode"
            />
          </el-select>
        </el-form-item>
      </template>
      <el-form-item label="收件人联系电话" prop="receiverPhone">
        <el-input
          v-model.trim="form.receiverPhone"
          placeholder="请输入收件人联系电话"
          @input="handleInput('receiverPhone')"
        />
      </el-form-item>
      <el-form-item label="是否默认" prop="isInvoiceDefault">
        <el-select v-model="form.isInvoiceDefault" placeholder="请选择是否默认">
          <el-option
            v-for="item in isInvoiceDefault"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <!-- 发票样式 -->
      <el-form-item label="发票示例" prop="invoiceDetailsSwitch">
        <el-radio-group v-model="form.invoiceDetailsSwitch">
          <el-radio :label="0">
            <span>合并展示</span>
            <span
              class="merge-display-preview-trigger"
              style="margin-left: 10px;color:#1890ff;cursor: pointer;"
              @click.stop="openInvoicePreview('merge')"
              >查看示例</span
            >
          </el-radio>
          <el-radio :label="1">
            <span>分开展示</span>
            <span
              class="merge-display-preview-trigger"
              style="margin-left: 10px;color:#1890ff;cursor: pointer;"
              @click.stop="openInvoicePreview('split')"
              >查看示例</span
            >
          </el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <el-dialog
      :title="`${previewDialogTitle}`"
      :visible.sync="previewDialogVisible"
      width="800px"
      append-to-body
    >
      <img
        :src="previewDialogImg"
        alt="发票示例"
        class="merge-display-preview-img"
      />
    </el-dialog>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">取 消</el-button>
      <el-button type="primary" @click="funcSubmit">确 定</el-button>
    </div>
  </div>
</template>
<script>
import {
  getInvoiceInfo,
  editInvoiceInfo,
  // getShipperList,
  addInvoiceInfo
} from "@/api/shipment";
import { validatePhone, validateTelephone } from "@/utils/validate";
export default {
  name: "InvoiceMessageAdd",
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          areaOptions: [],
          typeOptions: [],
          bankOptions: []
        };
      }
    }
  },
  data() {
    return {
      previewDialogVisible: false,
      previewDialogTitle: "",
      previewDialogImg: "",
      mergeDisplayPreviewImg: require("@/assets/login/hiuzong.png"),
      splitDisplayPreviewImg: require("@/assets/login/fenqu.png"),
      companyCode: "",
      detailType: "add",
      receiverUserCodeOptions: [],
      isReceiverUserCodeShow: false,
      // 是否默认状态
      isInvoiceDefault: [{ label: "否", value: 0 }, { label: "是", value: 1 }],
      form: {
        isInvoiceDefault: "",
        invoiceDetailsSwitch: 0,
        userCode: "",
        invoiceTitle: "",
        receiverPhone: "",
        taxRegistrationNumber: "",
        bank: "",
        accountNumber: "",
        registeredAddress: "",
        registeredFixedPhone: "",
        // type: '',
        receiverUserCode: ""
      },
      rules: {
        receiverUserCode: [
          { required: true, message: "请选择实际收票人", trigger: "change" },
          { min: 1, max: 255, message: "长度在 1 到 255个字符" }
        ],
        isInvoiceDefault: [
          { required: true, message: "请选择是否默认", trigger: "change" }
        ],
        invoiceDetailsSwitch: [
          { required: true, message: "请选择发票样式", trigger: "change" }
        ],
        invoiceTitle: [
          { required: true, message: "请输入发票抬头", trigger: "blur" },
          { min: 1, max: 255, message: "长度在 1 到 255个字符" }
        ],
        receiverPhone: [
          { required: true, message: "请输入收件人联系电话", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (!validatePhone(value) && !validateTelephone(value)) {
                callback(new Error("电话格式有误"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        type: [
          { required: true, message: "请选择开票类型", trigger: "change" }
        ],
        taxRegistrationNumber: [
          { required: true, message: "请输入纳税人识别号", trigger: "blur" },
          { min: 1, max: 128, message: "长度在 1 到 128个字符" }
        ],
        bank: [
          { required: true, message: "请选择基本开户银行", trigger: "change" }
        ],
        accountNumber: [
          { required: true, message: "请输入基本开户账号", trigger: "blur" },
          { min: 1, max: 32, message: "长度在 1 到 32个字符" }
        ],
        registeredAddress: [
          { required: true, message: "请输入注册场所地址", trigger: "blur" },
          { min: 1, max: 128, message: "长度在 1 到 128个字符" }
        ],
        registeredFixedPhone: [
          { required: true, message: "请输入注册固定电话", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (!validatePhone(value) && !validateTelephone(value)) {
                callback(new Error("电话格式有误"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.companyCode = this.$route.query.code ? this.$route.query.code : "";
    this.form.userCode = this.$route.query.partyCode
      ? this.$route.query.partyCode
      : "";
  },
  methods: {
    openInvoicePreview(type) {
      this.previewDialogTitle = type === "merge" ? "合并展示" : "分开展示";
      this.previewDialogImg =
        type === "merge"
          ? this.mergeDisplayPreviewImg
          : this.splitDisplayPreviewImg;
      this.previewDialogVisible = true;
    },
    handleInput(field) {
      const value = this.form[field];
      if (typeof value === "string") {
        this.form[field] = value.replace(/\s+/g, "");
      }
    },
    // 选择开票类型
    // changeType(value) {
    //   this.form.receiverUserCode = ''
    //   if (value === '0') {
    //     // 隐藏该项/取消验证
    //     this.isReceiverUserCodeShow = false
    //     this.rules.receiverUserCode.required = false
    //   }
    //   else {
    //     // 显示该项/增加验证
    //     this.isReceiverUserCodeShow = true
    //     this.rules.receiverUserCode.required = true
    //     const data = { staffType: 0 , companyCode: this.companyCode}
    //     switch (value) {
    //       case '1':
    //         data.staffType = 4
    //         break
    //       case '2':
    //         data.staffType = 6
    //         break
    //     }
    //     // 获取收票人选项
    //     getShipperList(data).then(response => {
    //       this.receiverUserCodeOptions = response.data.records
    //     })
    //   }
    // },
    getInfo(detailType, code) {
      this.detailType = detailType;
      this.$refs["form"].resetFields();
      if (code) {
        const rLoading = this.openLoading();
        getInvoiceInfo(code).then(response => {
          rLoading.close();
          this.form = response.data;
          this.form.type = this.form.type.toString();
          if (this.form.type === "0") {
            this.isReceiverUserNameShow = false;
            this.rules.receiverUserCode.required = false;
          }
          // this.getReceiverUserNameOptions(response.data.type);
        });
      }
    },
    // 获取实际收票人选项
    // getReceiverUserNameOptions(value) {
    //   const data = { staffType: 0 , companyCode: this.companyCode};
    //   switch (value) {
    //     case "1":
    //       data.staffType = 4;
    //       break;
    //     case "2":
    //       data.staffType = 6;
    //       break;
    //   }
    //   getShipperList(data).then(response => {
    //     this.receiverUserNameOptions = response.data.records;
    //   });
    // },
    funcSubmit() {
      this.$refs["form"].validate(async valid => {
        if (valid) {
          const rLoading = this.openLoading();
          let response =
            this.detailType == "add"
              ? await addInvoiceInfo(this.form)
              : await editInvoiceInfo(this.form);
          rLoading.close();
          this.$message({ message: response.msg, type: "success" });
          this.$emit("fatherAddMethod");
          this.$refs["form"].resetFields();
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "add");
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}

.merge-display-preview-img {
  width: 100%;
  height: auto;
}

.merge-display-preview-trigger {
  cursor: pointer;
  border-bottom: 1px dashed #909399;
}
</style>
